/**
 * Crate sources report duration in either seconds or milliseconds.
 * Spotify search results may also be formatted as "m:ss".
 * Anything under 10000 is treated as seconds (a 10000s track is ~2.8 hours).
 * Zero or negative values mean the source never knew the length (Serato
 * imports store 0), so they are reported as unknown rather than as 0ms.
 */
export function toDurationMs(
  duration?: number | string | null,
): number | undefined {
  if (duration == null || duration === '') {
    return undefined;
  }

  if (typeof duration === 'string') {
    const trimmed = duration.trim();
    if (trimmed.includes(':')) {
      const parts = trimmed.split(':').map((part) => Number(part));
      if (parts.length < 2 || parts.length > 3 || parts.some(Number.isNaN)) {
        return undefined;
      }
      const seconds =
        parts.length === 2
          ? parts[0] * 60 + parts[1]
          : parts[0] * 3600 + parts[1] * 60 + parts[2];
      return seconds > 0 ? Math.round(seconds * 1000) : undefined;
    }
    const numeric = Number(trimmed);
    if (Number.isNaN(numeric)) {
      return undefined;
    }
    return toDurationMs(numeric);
  }

  if (Number.isNaN(duration) || duration <= 0) {
    return undefined;
  }
  return duration < 10000 ? Math.round(duration * 1000) : Math.round(duration);
}
